import * as constants from '../constants/CONSTANT';
import authApi from './authApi';

import helper from '../components/common/helper';
const SparkApi = {
  //************************ Leads ***********************************//

  async Watconnectlogin(credentials) {
    try {
      let response = await fetch(
        constants.Watconnect_API_BASE_URL + '/api/auth/login',
        {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(credentials),
        }
      );

      const result = await response.json();
      if (result.success) {
        // ✅ Use different storage key to avoid overwriting Spark token
        localStorage.setItem('watconnect_token', result.authToken);
        localStorage.setItem('watconnect_refresh_token', result.refreshToken);
      }
      return result;
    } catch (error) {
      console.error('WatConnect login error:', error);
      return null;
    }
  },

  // -------------------send template---------------------

  async getTemplateaAmountBySetting(
    template_id,
    selectedWhatsAppSetting,
    start,
    end
  ) {
    const token = localStorage.getItem('watconnect_token');
    const url = `${constants.Watconnect_API_BASE_URL}/api/whatsapp_setting/templateprice/${template_id}/${selectedWhatsAppSetting}/${start}/${end}`;

    let response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();

    return result;
  },
  async getWhatsAppSettingRecord() {
    const token = localStorage.getItem('watconnect_token');
    let response = await fetch(
      constants.Watconnect_API_BASE_URL + '/api/whatsapp_setting',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();

    // if (result.length > 0) {

    return result;
    // }
    // return null;
  },

  async getAllTemplatesdata(number) {
    const token = localStorage.getItem('token');
    if (!number || number.trim() === '') {
      return [];
    }

    const url = `${constants.API_BASE_URL}/api/watconnect/alltemplate?whatsapp_setting_number=${number}`;
    //
    let response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();

    return result;
  },
  // --------------Get all Template in meta-------------
  async getAllTemplates(number) {
    if (!number || number.trim() === '') {
      return [];
    }

    const token = localStorage.getItem('watconnect_token');

    let response = await fetch(
      `${constants.Watconnect_API_BASE_URL}/api/webhook_template/alltemplate?whatsapp_setting_number=${number}`,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    const result = await response.json();
    console.log('getAllTemplates', result);
    return result;
  },

  //---------Create Marketing and utility Template in meta-------------
  async createMarketingTemplate(reqbody, number) {
    const token = localStorage.getItem('watconnect_token');

    let response = await fetch(
      `${constants.Watconnect_API_BASE_URL}/api/webhook_template/template?whatsapp_setting_number=${number}`,
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(reqbody),
      }
    );

    return await response.json();
  },
  // -------------update Marketing and utility Template-------------
  async updateMarketingTemplate(id, reqbody, number) {
    const token = localStorage.getItem('watconnect_token');
    const url = `${constants.Watconnect_API_BASE_URL}/api/webhook_template/template/${id}?whatsapp_setting_number=${number}`;
    let response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reqbody),
    });
    return await response.json();
  },

  // -----------------Get Template document generateSessionId----------------------
  async generateSessionId(file, number) {
    if (!number || number.trim() === '') {
      return [];
    }

    const token = localStorage.getItem('watconnect_token');

    const formData = new FormData();
    formData.append('files', file);

    let response = await fetch(
      `${constants.Watconnect_API_BASE_URL}/api/webhook_template?whatsapp_setting_number=${number}`,
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          Authorization: token, // Don't include Content-Type for FormData
        },
        body: formData,
      }
    );

    const result = await response.json();

    return result;
  },

  // -----------------Get Template document uploadDocumentSessionId--------------------
  async uploadDocumentSessionId(file, sessionId, number) {
    if (!number || number.trim() === '') {
      return [];
    }

    const token = localStorage.getItem('watconnect_token');

    const formData = new FormData();
    formData.append('files', file);
    formData.append('uploadSessionId', sessionId);

    let response = await fetch(
      `${constants.Watconnect_API_BASE_URL}/api/webhook_template/uploadsessionid?whatsapp_setting_number=${number}`,
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          Authorization: token,
        },
        body: formData,
      }
    );

    const result = await response.json();

    return result;
  },

  //................... Create Lead ................................
  async createLead(lead) {
    console.log('LEad Data=>>', lead);
    const token = localStorage.getItem('token');

    let response = await fetch(constants.API_BASE_URL + '/api/leads', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(lead),
    });
    return await response.json();
  },

  //................... Create Lead ................................
  async createBackup(lead) {
    const token = localStorage.getItem('token');

    let response = await fetch(constants.API_BASE_URL + '/api/backup', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(lead),
    });
    return await response.json();
  },

  //...................  Fetch All Lead ................................
  async fetchLead() {
    const token = localStorage.getItem('token');
    console.log(`constants.API_BASE_URL + "/api/leads"`);
    let response = await fetch(constants.API_BASE_URL + '/api/leads', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    console.log('Result Lead->>', result);
    // if (result.length > 0) {
    return result;
    // }
    // return null;
  },

  //...................  Fetch All Lead ................................
  async fetchBackups() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/backup', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //.............. Fetch Lead By Id .............................

  async fetchLeadById(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/leads/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const result = await response.json();

    return result;
  },

  //...................  Fetch All Business ................................
  async fetchBusiness() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/businesses', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //.............. Fetch Business By Id .............................

  async fetchBusinessById(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/businesses/' + id,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const result = await response.json();

    return result;
  },

  //...................  Fetch All Lead ................................

  async fetchUsers() {
    ////
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/auth/users', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    ////

    const result = await response.json();
    ////
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //.............. Fetch Lead By Id .............................
  async fetchUserById(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/auth/users/' + id,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const result = await response.json();
    ////
    return result;
  },

  //fetchMedicalTestItemByOwnerId
  async findLeadByOwnerId(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/leads/ld/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const result = await response.json();
    return result;
  },
  //.............. Update Lead .............................
  async updateLead(lead) {
    console.log('LEad->>>>>>>>>>>>>>', lead);
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/leads/' + lead.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(lead),
      }
    );
    return await response.json();
  },

  //.............. Update Lead .............................
  async updateBusiness(business) {
    //
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/businesses/' + business.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(business),
      }
    );
    return await response.json();
  },

  // .......... Delete Lead .............................
  async deleteLead(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/leads/' + id, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    return await response.json();
  },

  async deleteReport(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/reports/' + id, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    return await response.json();
  },

  // .......... Delete Lead .............................
  async deleteBusiness(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/businesses/' + id,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  //************************ Contacts ***********************************//

  //................... Create Contact ................................
  async createContact(contact) {
    const token = localStorage.getItem('token');

    let response = await fetch(constants.API_BASE_URL + '/api/contacts', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(contact),
    });
    return await response.json();
  },

  async saveContact(contact) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/contacts/' + contact.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(contact),
      }
    );
    return await response.json();
  },

  //................... Fetch All Contacts ................................
  async fetchContacts() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/contacts', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //----------------------------------Releted Contacts-----------------------------------
  async findContactByAccountId(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/accounts/' + id + '/contacts',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const result = await response.json();
    return result;
  },

  //************************ Task ***********************************//
  async fetchTasks(pid) {
    const token = localStorage.getItem('token');
    ///"+pid+"/*
    let response = await fetch(
      constants.API_BASE_URL + '/api/tasks/' + pid + '/*',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    ////
    const result = await response.json();
    ////
    if (result.length > 0) {
      ////
      return result;
    }
    return null;
  },

  async fetchMessages(pid) {
    const token = localStorage.getItem('token');
    ///"+pid+"/*
    let response = await fetch(
      constants.API_BASE_URL + '/api/messages/' + pid + '/*',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    ////
    const result = await response.json();
    ////
    if (result.length > 0) {
      ////
      return result;
    }
    return null;
  },

  async fetchUnreadMessages() {
    const token = localStorage.getItem('token');
    ///"+pid+"/*
    let response = await fetch(
      constants.API_BASE_URL + '/api/messages/unread',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    ////
    const result = await response.json();
    //
    if (result.length > 0) {
      ////
      return result;
    }
    return null;
  },

  async markReadMessage(notificationid) {
    const token = localStorage.getItem('token');
    ///"+pid+"/*
    let response = await fetch(
      constants.API_BASE_URL + '/api/messages/markread/' + notificationid,
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    ////
    const result = await response.json();
    //
    if (result.length > 0) {
      ////
      return result;
    }
    return null;
  },

  async deletePushNotification(notificationid) {
    const token = localStorage.getItem('token');
    ///"+pid+"/*
    let response = await fetch(
      constants.API_BASE_URL + '/api/messages/markdelete/' + notificationid,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    ////
    const result = await response.json();
    //
    if (result.length > 0) {
      ////
      return result;
    }
    return null;
  },

  //************************ Task ***********************************//
  async fetchBusinessByParent(pid) {
    const token = localStorage.getItem('token');
    ///"+pid+"/*
    let response = await fetch(
      constants.API_BASE_URL + '/api/businesses/' + pid + '/*',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    ////
    const result = await response.json();
    ////
    if (result.length > 0) {
      ////
      return result;
    }
    return null;
  },

  async fetchTasksWithoutParent() {
    const token = localStorage.getItem('token');

    let response = await fetch(
      constants.API_BASE_URL + '/api/tasks/opentasks',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    ////
    const result = await response.json();
    ////
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  async fetchAllMeetings(today) {
    const token = localStorage.getItem('token');

    let response = await fetch(
      constants.API_BASE_URL + '/api/tasks/meetings/today',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    ////
    const result = await response.json();
    ////
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  async createTask(task) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/tasks/', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(task),
    });

    return await response.json();
  },

  async createMessage(message) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/messages/', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(message),
    });

    return await response.json();
  },

  async sendEmailTask(task) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/tasks/sendemail',
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(task),
      }
    );

    return await response.json();
  },

  async saveTask(task) {
    ////
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/tasks/' + task.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(task),
      }
    );

    return await response.json();
  },

  async deleteTask(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/tasks/' + id, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    return await response.json();
  },

  async deleteMessage(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/messages/' + id, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    return await response.json();
  },

  // ***********************************Home Page***************************************** /api/common/newleads
  //...................  Fetch All New Leads ................................
  async fetchNewLeads() {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/common/newleads',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    return result;
    // if (result.length > 0) {
    //   return result;
    // }
    // return null;
  },
  async fetchallcontacts() {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/common/allcontacts',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    return result;
    // if (result.length > 0) {
    //   return result;
    // }
    // return null;
  },

  async fetchTotalBusiness() {
    //
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/common/totalbusiness',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    return result;
    // if (result.length > 0) {
    //   return result;
    // }
    // return null;
  },

  async fetchallActiveusers() {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/common/activeusers',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    return result;
    // if (result.length > 0) {
    //   return result;
    // }
    // return null;
  },

  async fetchLeadReports(reportname) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/reports/byname/' + reportname,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();

    return result;
  },

  async runReportByName(reportname) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/reports/run/' + reportname,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();

    return result;
  },

  async getCurrentUserTrackingRec() {
    const token = localStorage.getItem('token');
    ////
    let response = await fetch(
      constants.API_BASE_URL + '/api/usertrackings/track/currentrecord',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    ////
    if (result) {
      //////
      return result;
    }
    return null;
  },

  async saveStaffMemberEditProfile(userid, selectedFiles, staffMember) {
    console.log('Working this fucntion');
    console.log('useriduserid', userid);
    const formData = new FormData();
    formData.append('file', selectedFiles);
    formData.append('staffRecord', staffMember);
    ////
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/auth/' + userid + '/profile',
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          Authorization: token,
        },
        body: formData,
      }
    );
    ////
    return await response.json();
  },

  async createCheckInRecord(locationRecord) {
    const token = localStorage.getItem('token');
    ////

    let response = await fetch(constants.API_BASE_URL + '/api/usertrackings', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(locationRecord),
    });

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    ////
    if (result) {
      //////
      return result;
    }
    return null;
  },
  async fetchUsertrackingsWithstaffId(staffId) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/usertrackings/staff/' + staffId,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    const result = await response.json();
    ////
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  async fetchSystemNotifications(staffId) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/common/notifications',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    const result = await response.json();
    ////
    if (result && result.length > 0) {
      return result;
    }
    return null;
  },

  async handlCheckOut(locationRecord) {
    const token = localStorage.getItem('token');
    ////
    let response = await fetch(
      constants.API_BASE_URL + '/api/usertrackings/' + locationRecord.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(locationRecord),
      }
    );

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    ////
    if (result) {
      return result;
    }
    return null;
  },

  async getLoginUserData() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/auth/getuser', {
      method: 'GET',
      mode: 'cors',

      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
      return null;
    }
    const result = await response.json();
    console.log('getLoginUserData response:', result);

    // Handle new response format with success flag
    if (result.success && result.data) {
      return result.data;
    }

    // Fallback for old format (direct user object)
    return result;
  },

  async fetchFiles(parentId) {
    ////
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/files/' + parentId + '/all',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    const result = await response.json();
    ////
    ////
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  async updateUser(user) {
    ////
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/auth/updatepassword',
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(user),
      }
    );

    return await response.json();
  },

  async downloadFiles(fileid) {
    ////
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/files/' + fileid + '/download',
      {
        method: 'GET',
        //mode: "cors",

        headers: {
          Authorization: token,
        },
      }
    );
    const fileBody = await response.blob();
    //
    return fileBody;
  },

  async downloadBackupFile(filename) {
    ////
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/backup/download/' + filename,
      {
        method: 'GET',
        //mode: "cors",

        headers: {
          Authorization: token,
        },
      }
    );
    const fileBody = await response.blob();
    //
    return fileBody;
  },

  async deleteBackupFile(filename) {
    ////
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/backup/delete/' + filename,
      {
        method: 'GET',
        //mode: "cors",

        headers: {
          Authorization: token,
        },
      }
    );
    return await response.json();
  },

  //************************ Accounts ***********************************//

  //.................... Crate Account ...................................
  async createAccount(account) {
    const token = localStorage.getItem('token');

    let response = await fetch(constants.API_BASE_URL + '/api/accounts', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(account),
    });
    return await response.json();
  },

  async saveAccount(account) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/accounts/' + account.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(account),
      }
    );
    return await response.json();
  },

  //.......... Fetch All Accounts ..........................................
  async fetchAccounts() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/accounts', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }

    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //.............. Fetch Account By Id .............................
  async fetchAccountById(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/accounts/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const result = await response.json();

    return result;
  },

  //............. Delete Account ............................
  async deleteAccount(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/accounts/' + id, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    return await response.json();
  },

  //************************ Contacts ***********************************//

  //................... Create Contact ................................

  async createUser(user) {
    const token = localStorage.getItem('token');

    let response = await fetch(
      constants.API_BASE_URL + '/api/auth/createuser',
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(user),
      }
    );
    ////
    return await response.json();
  },

  /* Start updated by Pooja Vaishnav 12-07-2023 */
  async createUserMsgAlert(msgList) {
    //
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/messages/usermsg',
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(msgList),
      }
    );
    //
    return await response;
  },
  /* End updated by Pooja Vaishnav 12-07-2023 */

  async saveUser(user) {
    console.log('user=>>>', user);
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/auth/' + user.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(user),
      }
    );
    ////

    return await response.json();
  },

  //.............. Fetch Contact By Id .............................
  async fetchContact(id) {
    //
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/contacts/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const result = await response.json();

    return result;
  },

  //.............. Fetch Contact By Recordtype Id .............................
  async fetchContactByRecordtype(rtype) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/contacts/t/' + rtype,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const result = await response.json();

    return result;
  },

  //.............. Fetch Contact By Recordtype Id .............................
  async fetchContactByPhone(ph) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/contacts/p/' + ph,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const result = await response.json();

    return result;
  },

  // .......... Delete Contact .............................
  async deleteContact(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/contacts/' + id, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    return await response.json();
  },

  //************************ Products ***********************************//

  // .................. create product ...................................
  async createProduct(product) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/products', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(product),
    });
    return await response.json();
  },

  async saveLead(lead) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/leads/' + lead.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(lead),
      }
    );
    return await response.json();
  },

  //.................. save Product ............................/
  async saveProduct(product) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/products/' + product.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(product),
      }
    );
    return await response.json();
  },

  //................... Fetch All Products ..............................//
  async fetchProducts() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/products', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //.............. Fetch Product By Id .............................
  async fetchProduct(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/products/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const result = await response.json();

    return result;
  },

  //............. Delete Product .........................
  async deleteProduct(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/products/' + id, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    return await response.json();
  },

  //********************* Price Book *************************************

  //.................... Crate Pricebook ...................................
  async createPricebook(pricebook) {
    const token = localStorage.getItem('token');

    let response = await fetch(constants.API_BASE_URL + '/api/pricebooks', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(pricebook),
    });
    return await response.json();
  },

  async savePricebook(pricebook) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/pricebooks/' + pricebook.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(pricebook),
      }
    );
    return await response.json();
  },

  //.......... Fetch All Pricebooks........................................
  async fetchPricebooks() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/pricebooks', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }

    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //.............. Fetch Pricebook By Id .............................
  async fetchPricebook(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/pricebooks/' + id + '/*',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const result = await response.json();
    return result;
  },

  //----------------------------------Releted Pricebooks-----------------------------------
  async fetchPricebookByProductId(id) {
    //
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/pricebooks/' + id,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const result = await response.json();
    //
    return result;
  },

  //.............. Fetch Pricebook By Owner Id .............................
  async fetchPricebookByOwnerId(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/pricebooks/' + id + '/pid',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const result = await response.json();
    return result;
  },

  //.............. Fetch Pricebook By active Id .............................
  async fetchPricebookByActiveId(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/pricebooks/' + id + '/active',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    const result = await response.json();
    return result;
  },

  //............. Delete Pricebook ............................
  async deletePricebook(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/pricebooks/' + id,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    return await response.json();
  },

  //************* Payment ****************************/

  //.................... Create Payment ...................................
  async createPayment(payments) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/payments', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payments),
    });
    return await response.json();
  },
  async savePayment(payment) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/payments/' + payment.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(payment),
      }
    );
    return await response.json();
  },
  //.............. Fetch Payment By business id .............................
  async fetchPayments(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/payments/parent/' + id,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    const result = await response.json();
    return result;
  },

  //.............. Fetch Payment By  id .............................
  async fetchPaymentById(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/payments/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    const result = await response.json();
    return result;
  },

  async deletePayment(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/payments/' + id, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    return await response.json();
  },

  //****************** File  *******************

  async createFile(pid, formData) {
    const attachmentsApi = new (await import('../api/DataApi')).default(
      'attachments'
    );
    return attachmentsApi.post(`/${pid}`, formData);
  },

  //************************ files ***********************************//

  async saveFiles(file) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/files/' + file.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(file),
      }
    );

    return await response.json();
  },

  async convertLeadToContact(leadId, convertStatus) {
    //

    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/leads/convert/' + leadId,
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({ status: convertStatus }),
      }
    );
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  async deleteFile(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/files/' + id, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    return await response.json();
  },

  // --------------------------------- Report ----------------------------------------

  async fetchReports() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/reports', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  async fetchReportsById(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/reports/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    return await response.json();
  },

  //.............. Fetch Total Count of Accounts .............................
  async fetchCountOfAccounts() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/accounts/cnt', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    const result = await response.json();

    return result;
  },

  //.............. Fetch Total Count of Doctors in Contact......................
  async fetchCountOfDoctors() {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/contacts/total/dr',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const result = await response.json();

    return result;
  },

  //.............. Fetch Total Count of Patients in Contact......................
  async fetchCountOfPatients() {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/contacts/total/pt',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const result = await response.json();

    return result;
  },

  // --------------------------------- Commission ----------------------------------------
  async fetchCommissions() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/commissions', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  async createCommissions(commisson) {
    ////
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/commissions', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(commisson),
    });
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  async saveCommissions(commission) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/commissions/' + commission[0].id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(commission),
      }
    );
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  async deleteCommissions(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/commissions/' + id,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //Report Builder

  async fetchFilterQueryData(query) {
    //
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/reportbuilders/filter/' + query,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    const result = await response.json();
    //
    if (result.length > 0) {
      return result;
    }
    return null;
  },
  async fetchTableFields(tablename) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/reportbuilders/' + tablename,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },
  async fetchGroupbyQueryData(query) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/reportbuilders/groupbydata/' + query,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    //
    const result = await response.json();
    //

    return result;
  },
  async fetchTables() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/reportbuilders', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },
  async fetchAllReports() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/reports', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },
  async fetchQueryData(query) {
    //
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/reportbuilders/record/' + query,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    const result = await response.json();
    //
    //
    if (result.length > 0) {
      return result;
    }
    return null;
  },
  async createReport(reportdata) {
    //
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/reports', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reportdata),
    });
    return await response.json();
  },

  async fetchReportById(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/reports/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    const result = await response.json();
    //
    return result;
  },

  async savereport(id, data) {
    //
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/reports/' + id, {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(data),
    });
    return await response.json();
  },
  // --------------------------------- Report ----------------------------------------

  async fetchReports() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/reports', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //...................  Fetch All Incidents ................................
  async fetchIncidents() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/incidents', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },
  //................... Create Incident ................................
  async createIncident(incident) {
    //
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/incidents', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(incident),
    });
    return await response.json();
  },
  //.............. Fetch Incident By Id .............................
  async fetchIncidetById(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/incidents/' + id,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const result = await response.json();

    return result;
  },

  //.............. Update incident .............................
  async updateIncident(incident) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/incidents/' + incident.id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(incident),
      }
    );
    return await response.json();
  },

  // .......... Delete incident .............................
  async deleteIncident(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/incidents/' + id,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    return await response.json();
  },

  //................... Create Dashboard ................................
  async createDashboard(completedata) {
    //
    const token = localStorage.getItem('token');

    let response = await fetch(constants.API_BASE_URL + '/api/dashboards/', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(completedata),
    });
    return await response.json();
  },

  //...................  Fetch All Dashboard ................................
  async fetchAllDashboard() {
    const token = localStorage.getItem('token');
    let response = await fetch(constants.API_BASE_URL + '/api/dashboards/', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (response.status === 401) {
      await authApi.handleUnauthorized(response);
    }
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //.............. Fetch Dashboard By Id .............................

  async fetchDashboardById(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/dashboards/' + id,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    const result = await response.json();
    return result;
  },

  //.............. Update Dashboard .............................
  async saveDashboard(id, data) {
    //
    //

    //
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/dashboards/' + id,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  },
  // =============================================================================================================
  //--------------- @author  Muskan Khan---------
  // ---------------Date 9 June 2025-------------
  //----------------Watconnect Api-------------
  // =================================================================================================================
  //------------------Whatsapp Setting Start---------------

  // ------------Insert Watsapp Setting Record In db-----------
  async insertWhatsAppSettingRecords(reqbody) {
    const token = localStorage.getItem('token');

    let response = await fetch(
      constants.API_BASE_URL + '/api/whatsapp_setting',
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(reqbody),
      }
    );

    return await response.json();
  },

  // -----------Update Whatsapp Setting Record in db-----------
  async updateWhatsAppSettingRecord(data) {
    let response = await helper.fetchWithAuth(
      constants.API_BASE_URL + '/api/whatsapp_setting/' + data.id,
      'PUT',
      JSON.stringify(data)
    );
    return await response.json();
  },
  // ------Whatsapp Setting End---------

  // ---------Whatsapp Template Start------------

  // -----------------Get Template by name-----------------------------
  async getTemplateByName(name, number) {
    if (!number || number.trim() === '') {
      return [];
    }
    if (!name || name.trim() === '') {
      return [];
    }

    const token = localStorage.getItem('token');

    const url = `${
      constants.API_BASE_URL
    }/api/webhook_template/templatebyname?name=${encodeURIComponent(
      name
    )}&whatsapp_setting_number=${number}`;

    let response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();

    return result;
  },
  // -----------------Get Approved Template-----------------------------
  async getApprovedTemplates(number) {
    if (!number || number.trim() === '') {
      return [];
    }

    const token = localStorage.getItem('token');

    const url = `${constants.API_BASE_URL}/api/webhook_template/approved/template?whatsapp_setting_number=${number}`;

    let response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();

    return result;
  },

  // -----------------Get TemplateAmountBySetting--------------------
  async getTemplateAmountBySetting(
    template_id,
    selectedWhatsAppSetting,
    start,
    end
  ) {
    try {
      const token = localStorage.getItem('token');

      const url = `${constants.API_BASE_URL}/api/whatsapp_setting/templateprice/${template_id}/${selectedWhatsAppSetting}/${start}/${end}`;

      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      return await response.json();
    } catch (error) {
      console.error('Error fetching template amount:', error);
      return [];
    }
  },
  // ---------Authentication Template Upsert---------------------
  async upsertAuthTemplate(reqbody, number) {
    if (!number || number.trim() === '') {
      return [];
    }

    const token = localStorage.getItem('token');

    const url = `${constants.API_BASE_URL}/api/webhook_template/temp/auth?whatsapp_setting_number=${number}`;

    const response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reqbody),
    });

    return await response.json();
  },

  // ---------Delete Template in meta---------------------
  async deleteTemplateRecord(id, name, number) {
    if (!number || number.trim() === '') {
      return [];
    }

    const token = localStorage.getItem('token');

    const url = `${
      constants.API_BASE_URL
    }/api/webhook_template/template?hsm_id=${id}&name=${encodeURIComponent(
      name
    )}&whatsapp_setting_number=${encodeURIComponent(number)}`;

    let response = await fetch(url, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    return await response.json();
  },

  // ---------Delete Template in db field true isdeleted---------------------
  async isDeleted(id, name, number) {
    if (!number || number.trim() === '') {
      return [];
    }

    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/delete`;

    const payload = {
      template_id: id,
      template_name: name,
      number: number,
    };

    try {
      const response = await fetch(url, {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      return await response.json();
    } catch (error) {
      console.error('Delete API error:', error);
      return { success: false, error: error.message };
    }
  },

  async updatetemp(reqbody, selectedWhatsAppSetting) {
    const token = localStorage.getItem('token');

    const url = `${constants.API_BASE_URL}/api/watconnect/updatetemplate`;

    try {
      const response = await fetch(url, {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token, // Fix: Add Bearer prefix if your backend expects it
        },
        body: JSON.stringify(reqbody),
      });

      const responseData = await response.json();

      return responseData;
    } catch (error) {
      console.error('Update Template API Error:', error);
      return { success: false, error: error.message };
    }
  },
  // ---------Whatsapp Template End------------

  //--------- CREATE TEMPLATE IN DATABASE || START---------//
  // ------------------------Get All Template in DB------------------------
  async getApprovedtemplatedb() {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/approved`;
    //
    let response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();

    return result;
  },

  // ------------------------createMessageTemplateData in DB------------------------
  async createMessageTemplateData(reqbody) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/message/template`;

    let response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reqbody),
    });

    return await response.json();
  },
  // ------------------------createAuthenticationtempTemplate in DB----------------
  async createAuthenticationtemp(reqbody) {
    console.log('reqbody->', reqbody);
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/message/template/auth`;

    let response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reqbody),
    });

    return await response.json();
  },
  // ------------------------insertMsgHistoryRecords in DB----------------

  async insertMsgHistoryRecords(reqbody) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/message/history`;

    let response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reqbody),
    });

    return await response.json();
  },

  // -----------------Filter Chat Data----------------
  async getFilterData(textName, recordType) {
    const params = new URLSearchParams({
      textName: textName || '',
      recordType: recordType || '',
    }).toString();

    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/chat/filter?${params}`;

    let response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();

    return result;
  },

  // ---------------fetchUnreadMsgCount-------------
  async markMessagesAsRead(whatsappNumber, number) {
    // if (!number || number.trim() === "") {
    //   return [];
    // }

    // let response = await helper.fetchWithAuth(
    //   `${constants.API_BASE_URL}/api/watconnect/chat/mark_as_read?whatsapp_setting_number=${number}`,
    //   "POST",
    //   JSON.stringify({ whatsapp_number: whatsappNumber })
    // );
    // const result = await response.json();
    // return result;

    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/chat/mark_as_read?whatsapp_setting_number=${number}`;

    let response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({ whatsapp_number: whatsappNumber }),
    });

    return await response.json();
  },
  async fetchUnreadMsgCount(number) {
    if (!number || number.trim() === '') {
      return [];
    }
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/chat/unread_count?whatsapp_setting_number=${number}`;

    let response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();

    return result;
  },

  // ---------Whatsapp Chat Start------------
  async getMsgHistoryRecords(number, business_number) {
    if (!number || number.trim() === '') {
      return [];
    }
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/whatsapp/message/history/${number}?whatsapp_setting_number=${business_number}`;

    let response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();

    return result;
  },

  async sendSingleWhatsAppTextMessage(reqbody, number) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/webhook_template/single/message?whatsapp_setting_number=${number}`;

    let response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reqbody),
    });

    return await response.json();
  },
  async sendWhatsAppTemplateMessage(reqbody, number) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/webhook_template/message?whatsapp_setting_number=${number}`;

    let response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reqbody),
    });

    return await response.json();
  },
  // async uploadDocumentWithApi(file, number) {
  //   const token = localStorage.getItem("token");
  //   const url = `${constants.API_BASE_URL}/api/webhook_template/documentId?whatsapp_setting_number=${number}`;

  //

  //   try {
  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         Authorization: token,
  //         // Do NOT manually set Content-Type for FormData
  //       },
  //       body: file, // `file` should be a FormData object
  //     });

  //     if (!response.ok) {
  //       const errorText = await response.text();
  //       throw new Error(`HTTP ${response.status}: ${errorText}`);
  //     }

  //     const data = await response.json();
  //     return data;
  //   } catch (error) {
  //     console.error("Upload failed:", error);
  //     throw error;
  //   }
  // }
  async uploadDocumentWithApi(file, number) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/webhook_template/documentId?whatsapp_setting_number=${number}`;

    const formData = new FormData();
    formData.append('messaging_product', 'whatsapp');
    formData.append('file', file);

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: token,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Upload failed:', error);
      throw error;
    }
  },

  async historyDelete(id, number) {
    const token = localStorage.getItem('token');

    let response = await fetch(
      `${constants.API_BASE_URL}/api/watconnect/history/${id}?whatsapp_setting_number=${number}`, // ✅ backticks added
      {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  //************************* CREATE Campaign Records || START **********************************************//
  async getCampaignData(number) {
    if (!number || number.trim() === '') {
      return [];
    }
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/campaign?whatsapp_setting_number=${number}`;

    let response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();

    return result;
  },

  async insertCampaignRecords(reqbody) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/campaign`;

    let response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reqbody),
    });

    return await response.json();
  },

  async updateCampaignRecord(campaign) {
    const token = localStorage.getItem('token');

    const url = `${constants.API_BASE_URL}/api/watconnect/campaign/${campaign.id}`;

    let response = await fetch(url, {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(campaign),
    });

    return await response.json();
  },
  async downloadCampaignFile(filename) {
    const token = localStorage.getItem('token');

    const url = `${constants.API_BASE_URL}/api/watconnect/campaign/download/${filename}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: token,
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          return null;
        } else if (response.status === 401) {
          await authApi.handleUnauthorized(response);
          throw new Error('Unauthorized access. Please login.');
        } else {
          throw new Error(
            'Failed to download file. Status: ' + response.status
          );
        }
      }

      const fileBlob = await response.blob();
      return fileBlob;
    } catch (error) {
      console.error('Error downloading file:', error);
      throw error;
    }
  },

  async getMsgHistoryPercenatge(id) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/message/percentage?${id}`;

    try {
      let response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error fetching :', error);
      return [];
    }
  },

  async getMsgHistoryByStatus(id, status) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/message/status?id=${id}&status=${status}`;

    try {
      let response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error fetching :', error);
      return [];
    }
  },

  async getMsgHistoryDownload(id) {
    const token = localStorage.getItem('token');

    const url = `${constants.API_BASE_URL}/api/watconnect/message/history/download?${id}`;

    try {
      let response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error fetching :', error);
      return [];
    }
    // let response = await helper.fetchWithAuth(constants.API_BASE_URL + "/api/watconnect/message/history/download/" + id, 'GET');
    // const result = await response.json();
    // return result;
  },

  async deleteCampaignRecord(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/watconnect/campaign/' + id,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    return await response.json();

    // let response = await helper.fetchWithAuth(constants.API_BASE_URL + "/api/watconnect/campaign/" + id, 'DELETE');
    // return await response.json();
  },

  async createCampaignFile(id, formData) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/campaign/file/${id}`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: token,
        },
        body: formData,
      });

      const result = await response.json();

      return result;
    } catch (error) {
      console.error('Error uploading campaign file:', error);
      throw error;
    }
  },
  async insertCampaignParamsRecords(reqbody) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/campaign/params`;

    let response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reqbody),
    });

    return await response.json();
  },

  async cloneCampaignFile(fileData) {
    const token = localStorage.getItem('token');

    const response = await fetch(
      `${constants.API_BASE_URL}/api/watconnect/files/clone`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(fileData),
      }
    );

    const result = await response.json();
    return result;
  },
  //************************* CREATE Campaign Records || END **********************************************//

  // --------------------------Group Start In Db Store--------------------------------------------
  async fetchGroupsById(id) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/groups/${id}`;

    let response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();
    return result;
  },

  async createGroup(formData) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/groups`;

    const method = 'POST';

    try {
      const response = await fetch(url, {
        method,
        body: formData,

        headers: {
          Authorization: token,
        },
      });

      const jsonResponse = await response.json();

      if (!response.ok) {
        throw new Error(`Error: ${jsonResponse.message || 'Unknown error'}`);
      }

      return jsonResponse;
    } catch (error) {
      console.error('Failed to create group:', error);
      throw error;
    }
  },
  async fetchGroups(status) {
    const token = localStorage.getItem('token');
    const params = new URLSearchParams({
      status: status || '',
    }).toString();

    const url = `${constants.API_BASE_URL}/api/watconnect/groups?${params}`;

    try {
      let response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error fetching groups:', error);
      return [];
    }
  },
  async addMoreMembers(groupId, formData) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/groups/add_members/${groupId}`;
    const method = 'POST';

    try {
      const response = await fetch(url, {
        method,
        body: formData,
        headers: {
          Authorization: token,
        },
      });

      const jsonResponse = await response.json();

      if (!response.ok) {
        throw new Error(`Error: ${jsonResponse.message || 'Unknown error'}`);
      }

      return jsonResponse;
    } catch (error) {
      console.error('Failed to add members to group:', error);
      throw error;
    }
  },
  async changeGroupStatus(group_id, status) {
    const token = localStorage.getItem('token');

    let response = await fetch(
      `${constants.API_BASE_URL}/api/watconnect/groups/${group_id}/status`,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({ status }),
      }
    );

    return await response.json();
  },
  async deleteGroupMember(member_id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/watconnect/groups/member/' + member_id,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  // --------------------end group---------------------

  // -------------------REsposne messgae start-------------------------------
  async inserResponseMessageRecord(reqbody) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/response_message`;

    let response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reqbody),
    });

    return await response.json();
  },
  async updateResponseMessageRecord(data) {
    const createdid = data.id;
    const token = localStorage.getItem('token');

    let response = await fetch(
      `${constants.API_BASE_URL}/api/response_message/` + createdid,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(data),
      }
    );

    return await response.json();
  },

  async getResponseMessageData() {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/response_message`;

    let response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();
    return result;
  },

  async deleteResponseMessageRecord(id) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      constants.API_BASE_URL + '/api/response_message/' + id,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    return await response.json();
  },
  // -------------------REsposne messgae End-------------------------------
  // ------------------Billing start----------------------

  async getBillingCostsBySetting(selectedWhatsAppSetting, start, end) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/whatsapp_setting/billing-cost/${selectedWhatsAppSetting}/${start}/${end}`;

    let response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();
    return result;
  },

  // ------------------------------------------------------July 2025---------------------------------------------------------------
  async getModuleData(status) {
    console.log('working frontend');
    const token = localStorage.getItem('token');
    const queryParam = status ? `?status=${status}` : '';
    const url = `${constants.API_BASE_URL}/api/watconnect/module${queryParam}`;

    let response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();
    return result;
  },

  async insertModuleRecord(reqbody) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/module`;

    let response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reqbody),
    });

    return await response.json();
  },

  async updateModuleRecord(data) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/module/${data.id}`;

    let response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(data),
    });

    return await response.json();
  },

  async deleteModuleRecord(id) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/module/${id}`;

    let response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    return await response.json();
  },
  //-----------------------Plan module-----------------------

  async deletePlanRecord(id) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/plan/${id}`;

    let response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    return await response.json();
  },

  async updatePlanRecord(data) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/plan/${data.plan_info.id}`;

    let response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(data),
    });

    return await response.json();
  },
  async getPlanData(status = null) {
    const token = localStorage.getItem('token');
    const queryParam = status ? `?status=${status}` : '';
    const url = `${constants.API_BASE_URL}/api/watconnect/plan${queryParam}`;

    let response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();
    return result;
  },

  async getPlansById(id) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/plan/${id}`;

    let response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();
    return result;
  },

  async insertPlanRecord(reqbody) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/plan`;

    let response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(reqbody),
    });

    return await response.json();
  },

  async getAllAddons() {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/addons`;

    let response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();
    console.log('response', result);
    return result;
  },

  async createAddon(addon) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/addons`;

    let response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(addon),
    });

    return await response.json();
  },

  async updateAddon(addon) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/addons/${addon.id}`;

    let response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(addon),
    });

    return await response.json();
  },

  async deleteAddonRecord(id) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/addons/${id}`;

    let response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    return await response.json();
  },

  async generateInvoiceAddTransaction(records) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/invoice/generateInvoice/AddTrans/${records.invoice_id}`;

    console.log('🧾 Final Payload → records', records);

    let response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(records),
    });

    return await response.json();
  },
  // ================================Razarpay ==========================
  async getRazorPayData(obj) {
    const token = localStorage.getItem('access_token'); // Replace as needed

    const response = await fetch(
      constants.API_BASE_URL + '/api/watconnect/online_payment',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(obj),
      }
    );

    if (!response.ok) {
      throw new Error(`Error fetching Razorpay data: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  },
  // ================================Invoice Module==========================
  async sendInvoiceMail(imgData, invoiceData) {
    const token = localStorage.getItem('token');

    const response = await fetch(
      constants.API_BASE_URL + '/api/mail/invoice/',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({ imgData, invoiceData }),
      }
    );

    return await response.json();
  },
  async getInvoicesRecord(status) {
    const token = localStorage.getItem('token');
    const queryParam = status ? `?status=${status}` : '';
    console.log('query param=>', queryParam);
    const response = await fetch(
      constants.API_BASE_URL + `/api/invoice${queryParam}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    const result = await response.json();
    return result;
  },
  async getSetting(name) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      constants.API_BASE_URL + `/api/watconnect/common/setting/` + name,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    const result = await response.json();
    return result;
  },
  async addInvoiceWithTransaction(records) {
    const token = localStorage.getItem('access_token'); // Update if token is stored elsewhere

    const response = await fetch(
      constants.API_BASE_URL + '/api/invoice/invoiceWithTransaction',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(records),
      }
    );

    return await response.json();
  },
  async updateInvoiceAddTransaction(records) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      constants.API_BASE_URL +
        '/api/invoice/updateInvoiceAddTrans/' +
        records.id,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(records),
      }
    );

    return await response.json();
  },
  async fetchCompanyAndUserByInvoice(id) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      constants.API_BASE_URL + '/api/invoice/i/' + id,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    const result = await response.json();
    return result;
  },
  async updateInvoiceRecord(records) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      constants.API_BASE_URL + '/api/invoice/' + records.id,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(records),
      }
    );

    return await response.json();
  },
  async getInvoiceById(id) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      constants.API_BASE_URL + '/api/invoice/' + id,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    const result = await response.json();
    return result;
  },

  async getInvoicesByCompanyId(companyId) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      constants.API_BASE_URL + '/api/invoice/company/' + companyId,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    const result = await response.json();
    return result;
  },
  // ================================Company Module==========================
  async duplicateEmailCheck(email, id) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/company/emailcheck`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({ email, id }),
    });

    return await response.json();
  },
  async findCompanyWithUser(id) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/company/detail/${id}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();
    return result;
  },
  async fetchSourceSchemas() {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/company/all/getschema`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();
    return result;
  },

  async fetchCompany(is_active = null) {
    const queryParam = is_active ? `?is_active=${is_active}` : '';
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/company${queryParam}`;

    let response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();
    console.log('response', result);
    return result;
  },
  async updateCompanyWithUser(companyData) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/company/updateCompanyWithUser`;

    const formData = new FormData();
    formData.append('logo', companyData.company_info.logourl);
    formData.append('request', JSON.stringify(companyData));

    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        Authorization: token, // ❗ Do NOT set Content-Type manually with FormData
      },
      body: formData,
    });

    return await response.json();
  },
  // async createCompany(companyData) {
  //   const formData = new FormData();

  //   formData.append("logo", companyData.company_info.logourl);
  //   formData.append("request", JSON.stringify(companyData));

  //   let files = [companyData.company_info.logourl];
  //   formData.append("files", files);

  //   let response = await helper.fetchWithAuth(
  //     constants.API_BASE_URL + "/api/company",
  //     "POST",
  //     formData,
  //     "form"
  //   );
  //   return await response.json();
  // },

  async createCompany(companyData) {
    const formData = new FormData();

    // Append logo file (from file input)
    formData.append('logo', companyData.company_info.logourl);

    // Append rest of the data as JSON string
    formData.append('request', JSON.stringify(companyData));

    // Get token from localStorage
    const token = localStorage.getItem('token');

    // ✅ Use native fetch
    const response = await fetch(constants.API_BASE_URL + '/api/company', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`, // 👈 Auth header
        // ❌ Do not set Content-Type manually for FormData
      },
      body: formData,
    });

    return await response.json();
  },

  async updateCompany(records) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/company/${records.id}`;

    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(records),
    });

    return await response.json();
  },
  async getWalletTransactions() {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/wallet/transactions`;

    let response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const result = await response.json();
    return result;
  },

  async createWalletTransaction(payload) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/wallet`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    return await response.json();
  },

  async getWalletBalance() {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/wallet/balance`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    return await response.json();
  },

  async updateWalletTransaction(id, payload) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/wallet/${id}`;

    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    return await response.json();
  },

  async templateRates() {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/template_rates`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    return await response.json();
  },

  async checkBalance(payload) {
    const token = localStorage.getItem('token');
    const url = `${constants.API_BASE_URL}/api/watconnect/wallet/check_balance`;

    console.log('payload', payload);

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    return await response.json();
  },

  // Import Leads

  async importLeads(lead) {
    const token = localStorage.getItem('token');
    const response = await fetch(`${constants.API_BASE_URL}/api/leads/import`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(lead),
    });

    return await response.json();
  },
  async pinLead(leadId) {
    const token = localStorage.getItem('token');

    let response = await fetch(
      `${constants.API_BASE_URL}/api/leads/${leadId}/pin`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    return await response.json();
  },
  async unpinLead(leadId) {
    const token = localStorage.getItem('token');
    let response = await fetch(
      `${constants.API_BASE_URL}/api/leads/${leadId}/unpin`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  // Tag Module

  async getTags(status = null) {
    const token = localStorage.getItem('token');
    const queryParam = status ? `?status=${status}` : '';
    const url = `${constants.API_BASE_URL}/api/watconnect/tag`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    return await response.json();
  },
  async createTag(tag) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      `${constants.API_BASE_URL}/api/watconnect/tag`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(tag),
      }
    );
    return await response.json();
  },
  async updateTag(id, tag) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      `${constants.API_BASE_URL}/api/watconnect/tag/${id}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(tag),
      }
    );
    return await response.json();
  },
  async getTagById(id) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      `${constants.API_BASE_URL}/api/watconnect/tag/${id}?include_rules=true`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    return await response.json();
  },
  async resetPassword(data) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      `${constants.API_BASE_URL}/api/auth/resetPassword`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  },
  // ------------------Billing end----------------------
};
export default SparkApi;
